import type { Network } from "../types";

export const whatsapp: Network = {
  name: "WhatsApp",
  shareUrl: "https://api.whatsapp.com/send?text=[u]",
  args: {
    title: "%20[t]",
  },
  icon: "/media/images/social-share-whatsapp.png",
  color: "#25D366",
};
